<div *ngFor="let item of attributeDetails" class="parcel-container">
  <div class="parcel-input">
    <miq-text
      class="filter--text"
      [currentValue]="item[column.field.split('/')[1]]"
      (currentValueChange)="itemValueChanged(item, $event)"
      [required]="column.required"
      [column]="column"
      [disabled]="item.id !== 'undefined' && item.id !== null"
    ></miq-text>
    <div>
      <div class="close-icon">
        <mat-icon svgIcon="close-icon-green" (click)="removeArrayElement(item)"></mat-icon>
      </div>
    </div>
  </div>
</div>
<div class="add-icon" (click)="addArrayElement()">
  <mat-icon svgIcon="add-icon"></mat-icon>
  <span l10nTranslate>shared.add</span>
</div>
<div class="divider"></div>
<div class="done-icon" (click)="closeEditingBox()">
  <mat-icon svgIcon="done-icon"></mat-icon>
  <span l10nTranslate>shared.done</span>
</div>
